<script>
    let year = (new Date()).getFullYear();
</script>

<!-- App footer -->
<div class="appFooter">
    <div class="footer-title">{year} © ВСЕ ПРАВА ЗАЩИЩЕНЫ</div>
    <div>Международный институт интегративной нутрициологии</div>
</div>
<!-- * App footer -->
